import { CharacteristicType } from './characteristic-type.entity';
import { Serializable } from './serializable';

export class Characteristic implements Serializable<Characteristic> {
  private _uuid = '';
  public value = '';
  public characteristicType: CharacteristicType = null;
  public creationDate: Date = null;

  /**
   * Gets entity id
   * @returns entity id
   */
  public getId(): string {
    return this._uuid;
  }

  /**
   * Transforms received object to Characteristic entity
   * @param input
   * @returns Characteristic entity
   */
  public deserialize(input: any = {}): Characteristic {
    if (!input) {
      return null;
    }

    const properties = Object.getOwnPropertyNames(this);
    Object.keys(input).forEach((key) => {
      if (input[key] !== null) {
        switch (key) {
          case 'uuid':
            this._uuid = input[key];
            break;
          case 'characteristicType':
            this[key] = new CharacteristicType().deserialize(input[key]);
            break;
          case 'creationDate':
            this[key] = new Date(input[key]);
            break;
          default:
            if (properties.includes(key)) {
              this[key] = input[key];
            }
            break;
        }
      }
    });

    return this;
  }

  /**
   * Transforms Characteristic entity to json object
   * @returns json object
   */
  public serialize(): any {
    const output = {};

    Object.getOwnPropertyNames(this).forEach((property) => {
      switch (property) {
        case '_id':
          if (this[property]) {
            output['uuid'] = this[property];
          }
          break;
        case 'characteristicType':
          if (this.characteristicType) {
            output[property] = this.characteristicType.serialize();
          }
          break;
        case 'creationDate':
          output[property] =
            this[property] != null ? this[property].toString() : this[property];
          break;
        default:
          output[property] = this[property];
          break;
      }
    });

    return output;
  }
}
